
import SearchService from '../../apiclients/SearchService';
import FileService from '../../apiclients/FileService';
import IdentityService from '../../apiclients/IdentityService';

let USER_CACHE = {};

let getUsersData = async (processedUserSubs) => {
    let userSubsQuery = [];

    processedUserSubs.forEach((currentUserSub) => {
        let currResponse;
        if (USER_CACHE[currentUserSub]) {
            // console.log('user cache hit');
            currResponse = Promise.resolve(USER_CACHE[currentUserSub]);
        } else {
            // console.log('user cache miss');
            currResponse = IdentityService.getUser(
                currentUserSub
            ).then((data) => {
                return data;
            });
        }
        userSubsQuery.push(currResponse);
    });
    let results = await Promise.all(userSubsQuery).catch((err) => {
        console.log(err.message);
        return [];
    });

    let usersData = {};
    results.forEach((item) => {
        USER_CACHE[item.userSub] = item;
        usersData[item.userSub] = item;
    });

    return usersData;
};

let searchFiles = async (params, queryCounters, lastQueryId, loadMoreFromLastKey, tableData, fileType) => {
    try {
        //  console.log('search', params);
        let searchResponse = await SearchService.getSearchResults(
            params.query,
            params.author,
            params.resourceType,
            params.resourceSubtype,
            loadMoreFromLastKey,
            params.groupId,
        );

        // let searchResponse = await searchFiles(
        //     config,
        //     params
        // );
        // console.log('response', searchResponse);
        if (lastQueryId !== queryCounters.search) return;
        let lastKey = searchResponse.lastKey;


        let filesIds = searchResponse.results.map((file) => file.resourceId);
        let parsed = await parseResults(filesIds, fileType, loadMoreFromLastKey, tableData);
        parsed[`lastKey${fileType}`] = lastKey;
        return parsed;
    } catch (err) {
        if (lastQueryId !== queryCounters.search) return;
        console.log(err);
        return { tableData: [], };
    }
};

let parseResults = async (filesIds, fileType, loadMoreFromLastKey, tableData) => {
    try {
        // console.log('filesIds', filesIds, fileType, loadMoreFromLastKey, tableData)
        let files = await FileService.getFiles(
            filesIds
        );
        // console.log('files', filesIds, files);

        let dataItems = [];
        if (loadMoreFromLastKey) {
            dataItems = tableData;
        }
        if (files) {
            dataItems = dataItems.concat(files);
        }
        // console.log('items loaded: ', dataItems);

        let processedUserSubs = [];

        dataItems.forEach((element) => {
            if (processedUserSubs.indexOf(element.userSub) === -1) {
                processedUserSubs.push(element.userSub);
            }
        });

        let usersData = await getUsersData(processedUserSubs);
        // console.log('usersData', usersData)
        return { [`usersData${fileType}`]: usersData, [`tableData${fileType}`]: dataItems };
    } catch (err) {
        console.log(err);
        return { tableData: [], };
    }
};

export { searchFiles, parseResults, getUsersData };